(function ($, Drupal, once) {
  Drupal.behaviors.sidebarToggle = {
    attach: function (context, settings) {

      // Mobile sidebar toggle
      once('sidebar-toggle', '#sidebar-toggle', context).forEach(function (btn) {
        var $btn = $(btn);
        var $sidebar = $('#sidebar');
        var $overlay = $('#sidebar-overlay');

        if ($sidebar.length === 0 || $overlay.length === 0) {
          console.warn('Sidebar or overlay not found.');
          return;
        }

        $btn.on('click', function () {
          $sidebar.toggleClass('sidebar-open');
          $overlay.toggleClass('active');
          $btn.toggleClass('opened');
        });

        $overlay.on('click', function () {
          $sidebar.removeClass('sidebar-open');
          $overlay.removeClass('active');
          $btn.removeClass('opened');
        });
      });

    }
  };
})(jQuery, Drupal, once);
